export default __webpack_public_path__ + "static/media/menu_midi.ad4930b8.jpg";